import { render } from "./CaseStudyCard.vue?vue&type=template&id=3b3f7bc0&scoped=true"
import script from "./CaseStudyCard.vue?vue&type=script&lang=js"
export * from "./CaseStudyCard.vue?vue&type=script&lang=js"

import "./CaseStudyCard.vue?vue&type=style&index=0&id=3b3f7bc0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3f7bc0"]])

export default __exports__